import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'

import { LayoutPlain, Header } from 'components/layout'
import { MaterialLoader } from 'components/loaders'
import { apiPayment } from 'helpers/decorators/api'
import PropTypes from 'prop-types'

@apiPayment()
class PaymentInit extends Component {
  static propTypes = {
    proccessPaypalPayment: PropTypes.func
  }

  componentDidMount = () => {
    !__SERVER__ && this.props.proccessPaypalPayment()
  }

  render() {
    return (
      <LayoutPlain
        header={<Header isLocaleHidden />}
        body={[
          <div>
            <h1>
              <MaterialLoader />{' '}
              <span style={{ marginLeft: 10, position: 'relative', top: -7 }}>
                <FormattedMessage
                  id="label.processing_paypal_payment"
                  defaultMessage="Processing Paypal payment"
                />
              </span>
            </h1>
          </div>
        ]}
      />
    )
  }
}

export default PaymentInit
